module.exports = __webpack_public_path__ + "img/img-bebidas-bares.e256dde1.png";